export const ROUTES = {
  LOGIN: "/login",
  SET_PASSWORD: "/set-password",
  PARTICIPATION: "/participation",
  DASHBOARD: "/",
  COMPANIES: "/companies",
  COMPANY_ADD: "/companies/add",
  COMPANY_EDIT: "/companies/:id/edit",
  COMPANY_DASHBOARD: "/companies/:id/dashboard",
  SETUP: "/setup",
  RESULTS: "/results",
  FOOTPRINTS: "/footprints",
  FOOTPRINTS_CONSUMPTIONS: "/footprints/consumptions/:year",
  FOOTPRINTS_MATERIALS: "/footprints/consumptions/:year/materials",
  FOOTPRINTS_ELECTRICITY: "/footprints/consumptions/:year/electricity",
  FOOTPRINTS_FUELS: "/footprints/consumptions/:year/fuels",
  FOOTPRINTS_RESIDUOS: "/footprints/consumptions/:year/residue",
  FOOTPRINTS_WATER: "/footprints/consumptions/:year/water",
  SHARED_RESULTS: "/shared/:token",
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];
